import { createAjaxApiDeliveryClient } from './axiosClient';

interface ContentParams {
	contentId: string;
	lang?: string;
}

export const getAsideNaviData = async ({
	contentId,
	lang = 'en',
}: ContentParams) => {
	const client = createAjaxApiDeliveryClient({
		headers: {
			'Accept-Language': lang,
		},
	});

	const response = await client.get('KnowledgeBaseNavigation', {
		params: {
			pageId: contentId,
			lang: lang,
		},
		headers: { 'Accept-Language': lang },
	});
	return response.data;
};
